module.exports = new __parcel__URL__("LoomCrossSellPopupCardImage.6e60c328.png").toString();